export default "/images/07c59e6e2321dfd9cf2a60c7442e50de.png";